export { isChatApiConfigured } from '@/config/api/env'

const DEFAULT_CHAT_PATH = '/api/chat/completions'

export function getChatApiNotConfiguredMessage() {
  return (
    'No chat API is connected. Set VITE_API_BASE_URL or VITE_API_USE_RELATIVE=true. ' +
    `Optional: VITE_CHAT_COMPLETIONS_PATH (default ${DEFAULT_CHAT_PATH}).`
  )
}

export function chatCompletionsPath() {
  const path =
    (typeof import.meta.env.VITE_CHAT_COMPLETIONS_PATH === 'string' &&
      import.meta.env.VITE_CHAT_COMPLETIONS_PATH.trim()) ||
    DEFAULT_CHAT_PATH
  return path.startsWith('/') ? path : `/${path}`
}
